import { useEffect } from 'react';

// Tabler's icon-webfont glyphs are private-use-area codepoints with no sensible
// meaning in any fallback font, so whenever the browser falls back — which
// font-display:block/swap only delay, never prevent, once a slow connection makes
// the real font take longer than the timing trick's grace period — the fallback
// renders as a "tofu" box or a wrong CJK-range glyph instead of the intended icon.
// This keeps every .ti icon invisible (see the .ti / html.ti-fonts-ready rule in
// Sidebar.scss) until the browser confirms all page fonts have finished loading
// (or failed), however long that takes, then reveals them all at once — no
// in-between frame with the wrong glyph, regardless of connection speed.
export default function useTablerIconsReady() {
    useEffect(() => {
        if (!document.fonts?.ready) {
            document.documentElement.classList.add('ti-fonts-ready');
            return;
        }
        document.fonts.ready.then(() => {
            document.documentElement.classList.add('ti-fonts-ready');
        });
    }, []);
}
